// Lightweight bilingual strings — EN / PL
// All user-visible copy lives here; components pull via useT().

export const ASSETS = {
  video: "https://customer-assets.emergentagent.com/job_shiftlog-stage/artifacts/iccmktpy_ShiftLog%20Demo%20v3.mp4",
  screenshot_main: "https://customer-assets.emergentagent.com/job_shiftlog-stage/artifacts/avhyi21x_main%20page.jpg",
  screenshot_search: "https://customer-assets.emergentagent.com/job_shiftlog-stage/artifacts/mm44ct0n_search.jpg",
  screenshot_pdf: "https://customer-assets.emergentagent.com/job_shiftlog-stage/artifacts/bxcwk2un_pdf.jpg",
  founder: "https://customer-assets.emergentagent.com/job_shiftlog-stage/artifacts/1z5no91l_about-jarek.jpg",
};

export const LIVE_APP_URL = "https://shiftlog.jarekborowiec.com";

const dict = {
  en: {
    // nav
    "nav.product": "Product",
    "nav.features": "Features",
    "nav.demo": "Demo",
    "nav.pricing": "Pricing",
    "nav.resources": "Resources",
    "nav.bookDemo": "Book a demo",

    // hero
    "hero.badge": "Featured product",
    "hero.headline.a": "Every shift,",
    "hero.headline.b": "one source of truth.",
    "hero.sub": "ShiftLog replaces whiteboards, WhatsApp groups and half-filled logbooks with a structured, real-time layer for your plant floor. Capture handovers, track open issues and give the next shift exactly what they need to start the day.",
    "hero.cta.primary": "Book a demo",
    "hero.cta.secondary": "Try live demo",
    "hero.minutes": "~ 25 min · no obligation",
    "hero.credibility": "Built with feedback from production managers and team leaders across manufacturing environments.",

    // product
    "product.num": "01 — Product",
    "product.title.a": "A workspace built for the",
    "product.title.b": "shift floor,",
    "product.title.c": "not the boardroom.",
    "product.sub": "Clean, keyboard-first screens that operators actually use. Every module is designed around a real shift: what happened, what needs to happen next, and what the next supervisor needs to know.",
    "product.shot1.title": "Shift dashboard",
    "product.shot1.desc": "Confirm handovers, review open issues and see what the next shift needs — at a glance.",
    "product.shot2.title": "Filtered search",
    "product.shot2.desc": "Find any issue by severity, shift, machine or time window — exportable in one tap.",
    "product.shot3.title": "PDF reports",
    "product.shot3.desc": "Share clean, branded period reports with plant managers and auditors.",

    // features
    "features.num": "02 — Why ShiftLog",
    "features.title": "Built for operations leaders tired of paper, Excel and WhatsApp chaos",
    "features.f1.title": "Structured handovers, zero paperwork",
    "features.f1.desc": "Enforce the right fields per line & department. Outgoing shift signs off, incoming shift acknowledges. Every action is timestamped and tied to a person.",
    "features.f1.b1": "Role-based templates",
    "features.f1.b2": "Photo & file attachments",
    "features.f1.b3": "Works on tablet & shop-floor PC",
    "features.f2.title": "Metrics that roll up to your MD",
    "features.f2.desc": "Open vs resolved issues, critical counts, shift-over-shift trends — visible in the same place your team logs them.",
    "features.f3.title": "Audit-ready, always",
    "features.f3.desc": "Immutable log trail with user attribution and clean period-PDF exports.",
    "features.f4.title": "Works well in SAP environments",
    "features.f4.desc": "Built for teams already working in SAP PM, PP and QM environments.",
    "features.f5.title": "Live in 2 weeks",
    "features.f5.desc": "Pilot-first rollout. One line, one shift, one supervisor — then scale.",

    // demo
    "demo.num": "03 — Demo",
    "demo.title": "See a real shift, end-to-end.",
    "demo.sub": "A short walkthrough of how a supervisor closes a shift, flags an issue and hands over to the next team — without touching a single piece of paper.",
    "demo.liveCta": "Book live demo",

    // founder
    "founder.num": "04 — Why it exists",
    "founder.title": "Built by someone who has actually worked on the shop floor",
    "founder.p": "I spent 10+ years leading teams in manufacturing and logistics environments across Europe. I've seen how broken handovers create repeated issues, poor accountability and wasted time. ShiftLog was built to solve a problem I experienced firsthand.",
    "founder.signature": "Founder, ShiftLog",
    "founder.photo": "Founder photo",

    // pricing
    "pricing.num": "05 — Pricing",
    "pricing.title": "Simple pricing",
    "pricing.sub": "Start with a 2-week pilot before scaling plant-wide.",
    "pricing.perMonth": "/month",
    "pricing.standard.name": "Standard",
    "pricing.standard.price": "€499",
    "pricing.standard.b1": "Up to 20 users",
    "pricing.standard.b2": "Multiple production lines",
    "pricing.standard.b3": "Unlimited shift logs",
    "pricing.standard.b4": "Issue tracking",
    "pricing.standard.b5": "Manager dashboard",
    "pricing.standard.b6": "Photo attachments",
    "pricing.pro.name": "Professional",
    "pricing.pro.price": "€999",
    "pricing.pro.tag": "Most popular",
    "pricing.pro.b1": "Up to 50 users",
    "pricing.pro.b2": "Multiple teams",
    "pricing.pro.b3": "Advanced reporting",
    "pricing.pro.b4": "Priority support",
    "pricing.pro.b5": "Custom workflows",
    "pricing.pro.b6": "Everything in Standard",
    "pricing.ent.name": "Enterprise",
    "pricing.ent.price": "Custom",
    "pricing.ent.b1": "60+ users",
    "pricing.ent.b2": "Multiple plants",
    "pricing.ent.b3": "SSO",
    "pricing.ent.b4": "Integrations",
    "pricing.ent.b5": "Enterprise onboarding",
    "pricing.ent.b6": "Custom SLA",
    "pricing.cta": "Start pilot",
    "pricing.cta.ent": "Talk to us",

    // resources
    "resources.num": "06 — Resources",
    "resources.title": "Resources for operations teams",
    "resources.sub": "Field-tested material our customers asked us to keep available.",
    "resources.sap.tag": "Guide",
    "resources.sap.title": "The SAP Guide",
    "resources.sap.desc": "A hands-on field manual for operations teams working inside SAP PM, PP and QM — written by practitioners, not consultants.",
    "resources.sap.meta": "72 pages · PDF",
    "resources.sap.cta": "Get the guide",
    "resources.lean.tag": "Toolkit",
    "resources.lean.title": "Lean Toolkit",
    "resources.lean.desc": "Ready-to-use templates: A3, 5-Why, SMED, value-stream map, kaizen event kit. Fill in, print, run your workshop.",
    "resources.lean.meta": "18 templates · .xlsx + .pdf",
    "resources.lean.cta": "Get the toolkit",

    // contact
    "contact.num": "07 — Talk to us",
    "contact.title": "Book a demo or start a pilot.",
    "contact.sub": "Tell us a bit about your plant — we'll get back within one business day with a tailored walkthrough or a pilot scope.",
    "contact.b1": "25-minute walkthrough tailored to your line & sector",
    "contact.b2": "Optional 2-week pilot with one team before scaling",
    "contact.b3": "NDA and data residency options available on request",
    "contact.tab.demo": "Book a demo",
    "contact.tab.pilot": "Start pilot",
    "contact.firstName": "First name",
    "contact.lastName": "Last name",
    "contact.email": "Work email",
    "contact.company": "Company",
    "contact.teamSize": "Team size",
    "contact.plant": "Industry / Plant Type",
    "contact.teamSize.placeholder": "Select…",
    "contact.plant.placeholder": "e.g. Food & beverage · 3 lines",
    "contact.legal": "By submitting, you agree to be contacted about ShiftLog. No spam.",
    "contact.submit.demo": "Book my demo",
    "contact.submit.pilot": "Request pilot",
    "contact.submitting": "Submitting…",
    "contact.success.title": "Request received.",
    "contact.success.msg": "We'll get back to you within one business day.",

    // footer
    "footer.tagline": "Real-time shift intelligence for modern operations teams. Built with operators, in plants, on shift.",
    "footer.product": "Product",
    "footer.resources": "Resources",
    "footer.company": "Company",
    "footer.link.product": "Product",
    "footer.link.demo": "Demo",
    "footer.link.pricing": "Pricing",
    "footer.link.security": "Security",
    "footer.link.sap": "SAP Guide",
    "footer.link.lean": "Lean Toolkit",
    "footer.link.contact": "Contact",
    "footer.copyright": "© {year} ShiftLog — All rights reserved",
  },

  pl: {
    // nav
    "nav.product": "Produkt",
    "nav.features": "Funkcje",
    "nav.demo": "Demo",
    "nav.pricing": "Cennik",
    "nav.resources": "Materiały",
    "nav.bookDemo": "Umów demo",

    // hero
    "hero.badge": "Produkt flagowy",
    "hero.headline.a": "Każda zmiana,",
    "hero.headline.b": "jedno źródło prawdy.",
    "hero.sub": "ShiftLog zastępuje tablice, grupy na WhatsAppie i niekompletne zeszyty zmianowe ustrukturyzowaną warstwą w czasie rzeczywistym dla Twojej hali produkcyjnej. Prowadź zdania zmianowe, śledź otwarte problemy i daj następnej zmianie dokładnie to, czego potrzebuje na starcie.",
    "hero.cta.primary": "Umów demo",
    "hero.cta.secondary": "Zobacz działające demo",
    "hero.minutes": "~ 25 min · bez zobowiązań",
    "hero.credibility": "Rozwijany w oparciu o opinie kierowników produkcji i liderów zespołów pracujących w zakładach produkcyjnych.",

    // product
    "product.num": "01 — Produkt",
    "product.title.a": "Narzędzie zbudowane dla",
    "product.title.b": "hali produkcyjnej,",
    "product.title.c": "nie dla zarządu.",
    "product.sub": "Czyste ekrany zaprojektowane pod klawiaturę, z których operatorzy faktycznie korzystają. Każdy moduł jest zbudowany wokół prawdziwej zmiany: co się wydarzyło, co trzeba zrobić dalej i co następny brygadzista musi wiedzieć.",
    "product.shot1.title": "Panel zmiany",
    "product.shot1.desc": "Potwierdzaj zdania zmian, przeglądaj otwarte problemy i widź, czego potrzebuje następna zmiana — w jednym rzucie oka.",
    "product.shot2.title": "Wyszukiwanie z filtrami",
    "product.shot2.desc": "Znajdź dowolny problem po priorytecie, zmianie, maszynie lub oknie czasowym — eksportuj jednym kliknięciem.",
    "product.shot3.title": "Raporty PDF",
    "product.shot3.desc": "Dziel się czystymi, firmowymi raportami okresowymi z kierownikami zakładów i audytorami.",

    // features
    "features.num": "02 — Dlaczego ShiftLog",
    "features.title": "Dla liderów produkcji, którzy mają dość papieru, Excela i chaosu na WhatsAppie",
    "features.f1.title": "Ustrukturyzowane zdania zmiany, zero papierologii",
    "features.f1.desc": "Wymuś właściwe pola dla linii i działu. Odchodząca zmiana podpisuje, nadchodząca potwierdza. Każda czynność ze znacznikiem czasu i autorem.",
    "features.f1.b1": "Szablony ról",
    "features.f1.b2": "Załączniki: zdjęcia i pliki",
    "features.f1.b3": "Tablet i PC przy linii",
    "features.f2.title": "Metryki, które trafią do dyrektora",
    "features.f2.desc": "Otwarte vs zamknięte zgłoszenia, liczba krytycznych, trendy między zmianami — w tym samym miejscu, w którym zespół je rejestruje.",
    "features.f3.title": "Gotowe pod audyt, zawsze",
    "features.f3.desc": "Niezmienne ślady w logu z autorami i czystymi raportami okresowymi PDF.",
    "features.f4.title": "Dobrze działa w środowiskach SAP",
    "features.f4.desc": "Stworzony dla zespołów pracujących już w środowiskach SAP PM, PP i QM.",
    "features.f5.title": "Uruchomienie w 2 tygodnie",
    "features.f5.desc": "Wdrożenie od pilotażu. Jedna linia, jedna zmiana, jeden brygadzista — potem skalowanie.",

    // demo
    "demo.num": "03 — Demo",
    "demo.title": "Zobacz całą zmianę, od początku do końca.",
    "demo.sub": "Krótki przegląd, jak brygadzista zamyka zmianę, zgłasza problem i zdaje zmianę następnemu zespołowi — bez kawałka papieru.",
    "demo.liveCta": "Umów demo na żywo",

    // founder
    "founder.num": "04 — Dlaczego powstał",
    "founder.title": "Zbudowany przez kogoś, kto naprawdę pracował na hali",
    "founder.p": "Spędziłem ponad 10 lat prowadząc zespoły w produkcji i logistyce w Europie. Widziałem, jak złe zdania zmian generują powtarzające się problemy, brak odpowiedzialności i stratę czasu. ShiftLog powstał, żeby rozwiązać problem, który sam przeżyłem.",
    "founder.signature": "Założyciel, ShiftLog",
    "founder.photo": "Zdjęcie założyciela",

    // pricing
    "pricing.num": "05 — Cennik",
    "pricing.title": "Prosty cennik",
    "pricing.sub": "Zacznij od 2-tygodniowego pilotażu, zanim rozszerzysz na cały zakład.",
    "pricing.perMonth": "/miesiąc",
    "pricing.standard.name": "Standard",
    "pricing.standard.price": "€499",
    "pricing.standard.b1": "Do 20 użytkowników",
    "pricing.standard.b2": "Wiele linii produkcyjnych",
    "pricing.standard.b3": "Nielimitowane zapisy zmian",
    "pricing.standard.b4": "Śledzenie zgłoszeń",
    "pricing.standard.b5": "Panel dla kierownika",
    "pricing.standard.b6": "Załączniki zdjęciowe",
    "pricing.pro.name": "Professional",
    "pricing.pro.price": "€999",
    "pricing.pro.tag": "Najpopularniejszy",
    "pricing.pro.b1": "Do 50 użytkowników",
    "pricing.pro.b2": "Wiele zespołów",
    "pricing.pro.b3": "Zaawansowane raporty",
    "pricing.pro.b4": "Wsparcie priorytetowe",
    "pricing.pro.b5": "Niestandardowe procesy",
    "pricing.pro.b6": "Wszystko z pakietu Standard",
    "pricing.ent.name": "Enterprise",
    "pricing.ent.price": "Indywidualnie",
    "pricing.ent.b1": "Od 60 użytkowników",
    "pricing.ent.b2": "Wiele zakładów",
    "pricing.ent.b3": "SSO",
    "pricing.ent.b4": "Integracje",
    "pricing.ent.b5": "Wdrożenie enterprise",
    "pricing.ent.b6": "Indywidualne SLA",
    "pricing.cta": "Rozpocznij pilotaż",
    "pricing.cta.ent": "Porozmawiajmy",

    // resources
    "resources.num": "06 — Materiały",
    "resources.title": "Materiały dla zespołów produkcyjnych",
    "resources.sub": "Praktyczne materiały, które nasi klienci poprosili, żeby pozostały dostępne.",
    "resources.sap.tag": "Przewodnik",
    "resources.sap.title": "Przewodnik po SAP",
    "resources.sap.desc": "Praktyczny podręcznik dla zespołów produkcyjnych pracujących w SAP PM, PP i QM — pisany przez praktyków, nie konsultantów.",
    "resources.sap.meta": "72 strony · PDF",
    "resources.sap.cta": "Pobierz przewodnik",
    "resources.lean.tag": "Zestaw",
    "resources.lean.title": "Zestaw Lean",
    "resources.lean.desc": "Gotowe szablony: A3, 5-Why, SMED, mapa strumienia wartości, zestaw kaizen. Wypełnij, wydrukuj, prowadź warsztat.",
    "resources.lean.meta": "18 szablonów · .xlsx + .pdf",
    "resources.lean.cta": "Pobierz zestaw",

    // contact
    "contact.num": "07 — Porozmawiajmy",
    "contact.title": "Umów demo lub rozpocznij pilotaż.",
    "contact.sub": "Napisz krótko o swoim zakładzie — odezwiemy się w ciągu jednego dnia roboczego z dopasowanym pokazem lub planem pilotażu.",
    "contact.b1": "25-minutowy pokaz dopasowany do Twojej linii i branży",
    "contact.b2": "Opcjonalny 2-tygodniowy pilotaż z jednym zespołem przed skalowaniem",
    "contact.b3": "NDA i opcje przechowywania danych dostępne na życzenie",
    "contact.tab.demo": "Umów demo",
    "contact.tab.pilot": "Rozpocznij pilotaż",
    "contact.firstName": "Imię",
    "contact.lastName": "Nazwisko",
    "contact.email": "E-mail służbowy",
    "contact.company": "Firma",
    "contact.teamSize": "Wielkość zespołu",
    "contact.plant": "Branża / typ zakładu",
    "contact.teamSize.placeholder": "Wybierz…",
    "contact.plant.placeholder": "np. Spożywczy · 3 linie",
    "contact.legal": "Wysyłając zgadzasz się na kontakt w sprawie ShiftLog. Żadnego spamu.",
    "contact.submit.demo": "Umów demo",
    "contact.submit.pilot": "Poproś o pilotaż",
    "contact.submitting": "Wysyłanie…",
    "contact.success.title": "Wiadomość odebrana.",
    "contact.success.msg": "Odezwiemy się w ciągu jednego dnia roboczego.",

    // footer
    "footer.tagline": "Inteligencja zmian w czasie rzeczywistym dla nowoczesnych zespołów produkcyjnych. Budowana z operatorami, w zakładach, na zmianie.",
    "footer.product": "Produkt",
    "footer.resources": "Materiały",
    "footer.company": "Firma",
    "footer.link.product": "Produkt",
    "footer.link.demo": "Demo",
    "footer.link.pricing": "Cennik",
    "footer.link.security": "Bezpieczeństwo",
    "footer.link.sap": "Przewodnik SAP",
    "footer.link.lean": "Zestaw Lean",
    "footer.link.contact": "Kontakt",
    "footer.copyright": "© {year} ShiftLog — Wszelkie prawa zastrzeżone",
  },
};

export const translate = (lang, key, vars = {}) => {
  const t = dict[lang] || dict.en;
  let s = t[key] ?? dict.en[key] ?? key;
  Object.keys(vars).forEach((k) => {
    s = s.replace(`{${k}}`, vars[k]);
  });
  return s;
};

export const SUPPORTED_LANGS = ["en", "pl"];
